// Cookie consent state. Only strictly necessary storage (cart, age check,
// language) is used until the visitor opts in to more.
const KEY = 'cookie_consent';
const VERSION = 1;
export const CONSENT_EVENT = 'consentchange';
export const OPEN_SETTINGS_EVENT = 'open-cookie-settings';

export const getConsent = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY));
    return raw && raw.v === VERSION ? raw : null;
  } catch {
    return null;
  }
};

const gtagConsent = ({ analytics, marketing }) => {
  if (typeof window.gtag !== 'function') return;
  window.gtag('consent', 'update', {
    analytics_storage: analytics ? 'granted' : 'denied',
    ad_storage: marketing ? 'granted' : 'denied',
    ad_user_data: marketing ? 'granted' : 'denied',
    ad_personalization: marketing ? 'granted' : 'denied',
  });
};

export const setConsent = ({ analytics = false, marketing = false }) => {
  const value = { v: VERSION, analytics: Boolean(analytics), marketing: Boolean(marketing), ts: new Date().toISOString() };
  try {
    localStorage.setItem(KEY, JSON.stringify(value));
  } catch {
    // storage blocked: the choice still applies for this page view
  }
  gtagConsent(value);
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: value }));
  return value;
};

// Re-apply a stored choice on page load (consent defaults to "denied" in index.html).
export const applyStoredConsent = () => {
  const c = getConsent();
  if (c) gtagConsent(c);
};

export const openCookieSettings = () => window.dispatchEvent(new Event(OPEN_SETTINGS_EVENT));
